export const LogoMark = ({ className = "h-10 w-auto" }) => (
  <img
    src="/logo.png"
    alt="TSS - ADVOGADOS"
    data-testid="logo-mark"
    className={`${className} object-contain`}
  />
);

export const LogoFull = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="logo-full">
    <LogoMark className={compact ? "h-8 w-auto" : "h-11 w-auto"} />
    <div className="leading-none">
      <p className="font-display font-bold tracking-wide text-slate-100 text-base sm:text-lg">
        TSS <span className="gold-text">—</span> ADVOGADOS
      </p>
      {!compact && (
        <p className="font-mono-num text-[9px] sm:text-[10px] uppercase tracking-[0.28em] text-amber-400/80 mt-1.5">
          Jurídico de Resultados
        </p>
      )}
    </div>
  </div>
);
